// export const isEnglishString = (val: any): boolean => {
//   // Check if the value is not a string
//   if (typeof val !== 'string') {
//     return false;
//   }


//   // Allow empty string
//   if (val === "") {
//     return true;
//   }

//   // Regular expression to check if the string contains only English letters and single spaces between words, allowing one trailing space
//   const regex = /^[A-Za-z]+(?: [A-Za-z]+)*( )?$/;

//   // Test the string against the regular expression
//   return regex.test(val);
// };

export const isEnglishString = (val: any): boolean => {
  // Check if the value is not a string
  if (typeof val !== 'string') {
    return false;
  }

  // Allow empty string
  if (val === '') {
    return true;
  }

  // Regular expression to check if the string contains only English letters, Arabic characters, single spaces between words, and allows one trailing space
  const regex = /^[A-Za-z\u0600-\u06FF]+(?: [A-Za-z\u0600-\u06FF]+)*( )?$/;

  // Test the string against the regular expression
  return regex.test(val);
};

export const isFloat = (val: any) => {
  if (val[val.length - 1] === ' ' || val === '.' || val === '0') {
    return false;
  }
  if (val.includes('.')) {
    val = val.replace('.', '');
    if ((!val.includes('.') && !isNaN(val?.trim())) || val === '') {
      return true;
    }
    return false;
  }
  if (!isNaN(val?.trim()) || val === '') {
    return true;
  }
  return false;
};
export function isValidEmail(email: string) {
  // Regular expression pattern for a valid email address
  const emailPattern = /^[\w.%+-]+@[\w.-]+\.[a-zA-Z]{2,}$/;

  // Test if the email matches the pattern
  return emailPattern.test(email);
}
export const isNumber = (val: any) => {
  if (val[val.length - 1] === ' ') {
    return false;
  }
  if (val.includes('.')) {
    return false;
  }
  if (!isNaN(val?.trim()) || val === '') {
    return true;
  }
  return false;
};

export const isValidInput = (value: string) => {
  if (value === '') {
    return true;
  }
  if (value.trim() === '') {
    return false; // Reject if the value is empty or only consists of whitespace
  }

  if (value.includes('  ') || value.includes('..')) {
    return false; // Reject if there are consecutive spaces or decimals
  }

  return true; // Accept the input if it meets all the conditions
};
interface WordValidationOptions {
  minWords?: number;
  maxWords: number;
  allowEmpty?: boolean;
  trim?: boolean;
}

export const validateImageDimensions = (
  file: File,
  requiredWidth?: number,
  requiredHeight?: number,
): Promise<boolean> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);

    img.onload = () => {
      const { width, height } = img;
      // if ((width === requiredWidth) && height === requiredHeight) {
      if (requiredWidth && requiredHeight) {
        if (
          width >= requiredWidth - 10 &&
          width <= requiredWidth + 10 &&
          height >= requiredHeight - 10 &&
          height <= requiredHeight + 10
        ) {
          resolve(true);
        } else {
          resolve(false);
        }
      } else if (requiredWidth) {
        if (width >= requiredWidth - 10 && width <= requiredWidth + 10) {
          resolve(true);
        } else {
          resolve(false);
        }
      } else if (requiredHeight) {
        if (height >= requiredHeight - 10 && height <= requiredHeight + 10) {
          resolve(true);
        } else {
          resolve(false);
        }
      } else if (!requiredHeight && !requiredWidth) {
        resolve(true);
      } else {
        resolve(false);
      }
    };

    img.onerror = () => {
      resolve(false);
    };
  });
};

export const validateImageDimensions1 = (
  file: File,
  requiredWidth?: number,
  requiredHeight?: number,
): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);

    img.onload = () => {
      // if neither width nor height is passed → always valid
      if (!requiredWidth && !requiredHeight) {
        URL.revokeObjectURL(objectUrl);
        return resolve(true);
      }

      const isValidWidth = requiredWidth ? img.width === requiredWidth : true;
      const isValidHeight = requiredHeight ? img.height === requiredHeight : true;

      URL.revokeObjectURL(objectUrl);
      resolve(isValidWidth && isValidHeight);
    };

    img.onerror = (err) => {
      URL.revokeObjectURL(objectUrl);
      reject(err);
    };

    img.src = objectUrl;
  });
};

export const wordValidations = (
  input: string,
  options: WordValidationOptions,
): { isValid: boolean; message: string; wordCount: number } => {
  const { minWords = 0, maxWords, allowEmpty = false, trim = true } = options;

  if (!input || typeof input !== 'string') {
    return {
      isValid: allowEmpty,
      message: allowEmpty ? '0 words' : 'Input is required',
      wordCount: 0,
    };
  }

  // Clean the input
  const processedInput = trim ? input.trim() : input;

  // Count words (handle multiple spaces, tabs, newlines)
  const words =
    processedInput === '' ? [] : processedInput.split(/\s+/).filter((word) => word.length > 0);
  const wordCount = words.length;

  if (wordCount === 0) {
    return {
      isValid: allowEmpty,
      message: allowEmpty ? '0 words' : 'Please enter some text',
      wordCount: 0,
    };
  }

  if (wordCount < minWords) {
    return {
      isValid: false,
      message: `Minimum ${minWords} word${minWords !== 1 ? 's' : ''} required. You have ${wordCount} word${wordCount !== 1 ? 's' : ''}.`,
      wordCount,
    };
  }

  if (wordCount > maxWords) {
    return {
      isValid: false,
      message: `Maximum ${maxWords} word${maxWords !== 1 ? 's' : ''} allowed. You have ${wordCount} word${wordCount !== 1 ? 's' : ''}.`,
      wordCount,
    };
  }

  return {
    isValid: true,
    message: `${wordCount}/${maxWords} words`,
    wordCount,
  };
};
